export default "__VITE_ASSET__DdksELor__"